import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { MarketProvider } from './context/MarketContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <MarketProvider>
        <App />
      </MarketProvider>
    </AuthProvider>
  </React.StrictMode>
);